import request from '@/utils/request';
export function policyList(data) {
  return request.post('admin/policy/list', data);
}
export function downloadPolicy(data) {
  return request.post('admin/policy/export', data);
}
export function policyDetail(data) {
  return request.post('admin/policy/detail', data);
}
//根据保险id获取录入参数(保险人.被保险人)
export function policyRendering(data) {
  return request.post('admin/insurance/rendering-list', data);
}
//模板code返回下拉配置选项
export function policyTempConfig(data) {
  return request.post('admin/unit/temp-config', data);
}
export function claimsTempConfig(data) {
  return request.post('admin/claims-temp/config', data);
}
export function policyZip(data) {
  return request.post('admin/policy/zip', data);
}
export function policyInsuredInfo(data) {
  return request.post('admin/policy/insured-info', data);
}
export function editPolicy(data) {
  return request.post('admin/policy/edit', data);
}
export function exportZip(data) {
  return request.post('admin/policy/export-zip', data);
}
export function policyResource(data) {
  return request.post('admin/policy/resource', data);
}
export function getTags(data) {
  return request.post('admin/policy/getTags', data);
}
export function getAllFieldList(data) {
  return request.post('admin/policy/get-list-field', data);
}
export function editUserField(data) {
  return request.post('admin/policy/edit-user-field', data);
}
export function getPersonnelDetail(data) {
  return request.post('admin/policy/personnel-details/resource', data);
}
export function getOccupationResource(data) {
  return request.post('admin/policy/occupation/resource', data);
}
export function getPersonnelDetailList(data) {
  return request.post('admin/policy/personnel-details/list', data);
}
export function personnelDetailsDetail(data) {
  return request.post('admin/policy/personnel-details/detail', data);
}
export function personnelDetailsRecord(data) {
  return request.post('admin/policy/personnel-details-record/list', data);
}
export function personnelDetailsRecordDetail(data) {
  return request.post('admin/policy/personnel-details-record/detail', data);
}
// 保单号资源
export function policyNoResource(data) {
  return request.post('admin/policy/personnel-details-record/policyNo/resource', data);
}
// 操作人资源
export function operatorResource(data) {
  return request.post('admin/policy/personnel-details-record/operator/resource', data);
}
// 导出人员明细
export function personnelDetailExport(data) {
  return request.post('admin/policy/personnel-details-record/export', data);
}
export function personnelDetailEdit(data) {
  return request.post('admin/policy/personnel-details/edit', data);
}
export function personnelDetailsRecordPrompt(data) {
  return request.post('admin/policy/personnel-details-record/export/prompt', data);
}

//批单列表
export function endorsementList(data) {
  return request.post('admin/endorsement/list', data);
}

//生成批单 生成并发送批单
export function endorsementCreate(data) {
  return request.post('admin/policy/personnel-details-record/endorsement-export', data);
}

//人员明细导出
export function personnelDetailsExport(data) {
  return request.post('admin/policy/personnel-details/export', data);
}
//退保详情
export function cancelInfo(data) {
  return request.post('admin/policy/get-cancel-info', data);
}
//退保详情
export function cancelPolicy(data) {
  return request.post('admin/policy/cancel-policy', data);
}
export function checkAndPreviewEndorsement(data) {
  return request.post('admin/policy/personnel-details-record/check-endorsement-export', data);
}
export function endorsementExportSend(data) {
  return request.post('admin/policy/personnel-details-record/endorsement-export-send', data);
}
export function correctionRecordList(data) {
  return request.post('admin/policy/correct-record/list', data);
}
export function correctionRecordDetail(data) {
  return request.post('admin/policy/correct-record/detail', data);
}
export function correctionRecordExport(data) {
  return request.post('admin/policy/correct-record/personnel-export', data);
}
export function batchRecordExport(data) {
  return request.post('admin/policy/correct-record/export', data);
}
export function batchDownRecordVerify(data) {
  return request.post('admin/policy/correct-record/export-verify', data);
}
export function recordExportVerify(data) {
  return request.post('admin/policy/correct-record/personnel-export-verify', data);
}